import React, { ReactElement, useEffect, useState } from 'react';
import { Button, IconButton, ListItem, Typography } from '@mui/material';
import { burgerButtons } from '../../../../../menu';
import burgerMenu from '../../../../../assets/ui-icons/burgerButton-white.svg';
import blueBurgerMenu from '../../../../../assets/ui-icons/burgerbutton.svg';
import MenuButton from '../MenuButton';
import Dropdown, { DropdownMenu, DropdownToggle } from '../../../../bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import { AUTH_ROLE } from '../../../../../constants/auth.constants';
import { getFromLocalStorage } from '../../../../../utils/storage.util';

interface IReactiveDrawerMenuProps {
	iconSize?: string;
	color?: string;
}

//This component is a container for the drawer menu.
const ReactiveDrawerMenu: React.FC<IReactiveDrawerMenuProps> = ({ iconSize, color }): ReactElement => {
	const [open, setOpen] = useState(false);
	const [userType, setUserType] = useState<string>('');

	const [windowWidht, setWindowWidht] = useState(window.innerWidth);
	useEffect(() => {
		const handleResize = () => {
			setWindowWidht(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const navigate = useNavigate();

	const handleDrawerOpen = (event: React.MouseEvent<HTMLElement>): void => {
		setOpen(true);
	};

	const handleMenuClose = (): void => {
		setOpen(false);
	};

	//set the user type based on the user role for the fakeuser. Make a switch for the different usertypes
	useEffect((): void => {
		setUserType(getFromLocalStorage(AUTH_ROLE) ?? '');
	}, []);

	const goToPage = (page: string) => {
		navigate(`../${page}`);
		handleMenuClose();
	}

	return (
		<Dropdown isOpen={open} setIsOpen={setOpen}>
			<DropdownToggle hasIcon={false}>
				<IconButton aria-label='open drawer' className='show-icon' aria-haspopup='true' onClick={(event): void => handleDrawerOpen(event)} edge='end'>
					{windowWidht < 769 ? <MenuButton iconSrc={blueBurgerMenu} iconSize={iconSize} onClick={(): void => {}} /> : <MenuButton iconSrc={burgerMenu} iconSize={iconSize} onClick={(): void => {}} />}
				</IconButton>
			</DropdownToggle>

			<DropdownMenu
				style={{
					position: 'absolute',
					top: 82,
					right: 0,
					display: 'flex',
					justifyContent: 'flex-end',
					flexDirection: 'column',
				}}>
				{burgerButtons(userType).map((item, index): ReactElement => {
					return (
						<ListItem key={index}>
							<Button onClick={(): void => goToPage(`../${item.path}`)} style={{ width: '16rem' }}>
								<Typography
									variant='subtitle1'
									component='div'
									sx={{
										fontFamily: 'Poppins',
										fontWeight: '500',
										fontSize: '1rem',
									}}>
									{item.text.toUpperCase()}
								</Typography>
							</Button>
						</ListItem>
					);
				})}
			</DropdownMenu>
		</Dropdown>
	);
};

export default ReactiveDrawerMenu;
